/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { QaCheck } from '../../models/qa-check';

export interface GetQaChecksForContainer$Params {
  productionOrderId: number;
}

export function getQaChecksForContainer(http: HttpClient, rootUrl: string, params: GetQaChecksForContainer$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<QaCheck>>> {
  const rb = new RequestBuilder(rootUrl, getQaChecksForContainer.PATH, 'get');
  if (params) {
    rb.path('productionOrderId', params.productionOrderId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<QaCheck>>;
    })
  );
}

getQaChecksForContainer.PATH = '/api/v1/QaCheck/{productionOrderId}/GetContainerQaCheck';
